import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class DictionaryLearningGraph extends AbstractScatterVisualization {}
